import React from 'react';
import PropTypes from 'prop-types';

const MissingEntry = ({ id, buyMissingDockets, missing }) => (
  <tr key={`missing-entry-${id}`} className="missing-dockets">
    <td colSpan="5">
      <div>
        <span>Missing Docket Entries</span>
        <button onClick={buyMissingDockets.bind(null, missing)}>Fetch Missing Entries Now</button>
      </div>
    </td>
  </tr>
);

MissingEntry.propTypes = {
  id: PropTypes.string.isRequired,
  buyMissingDockets: PropTypes.func.isRequired,
  missing: PropTypes.object.isRequired,
};

export default MissingEntry;



// WEBPACK FOOTER //
// ./src/components/case/docket/docketEntries/MissingEntry.jsx